export const ACKNOWLEDGE = 'ACKNOWLEDGE';
export const FINALIZE = 'FINALIZE';
export const INITIALIZE = 'INITIALIZE';
